<template>
  <v-form ref="form">
    <v-text-field
      v-if="edit"
      v-model="sectionName"
      :label="$t('message.storeLocator.extraInfo.sectionName')"
      class="form"
    >
    </v-text-field>
    <div v-for="(element, index) in elements" :key="element.id" class="form">
      <v-text-field
        v-model="element.text"
        :label="fieldsLabels.text"
        v-validate="'required'"
        :data-vv-name="`text_${index}`"
        :error-messages="collectErrors(`text_${index}`)"
      ></v-text-field>
      <v-text-field
        v-model="element.url"
        :label="fieldsLabels.url"
        v-validate="'required|url|protocol'"
        :data-vv-name="`url_${index}`"
        :error-messages="collectErrors(`url_${index}`)"
      ></v-text-field>
    </div>
    <ui-button shadow icon="icon-plus" class="btn" @click="addForm">
      {{ $t("message.storeLocator.extraInfo.addNewElement") }}
    </ui-button>
    <ui-button
      v-if="elements.length > 1"
      shadow
      icon="icon-minus"
      class="btn"
      @click="removeForm"
    >
      {{ $t("message.storeLocator.extraInfo.removeElement") }}
    </ui-button>
  </v-form>
</template>

<script>
export default {
  name: "LinkSectionForm",
  props: {
    data: Array,
    name: String,
    edit: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.sectionName = this.name || "";
    this.elements = this.data.length
      ? this.data
      : [
          {
            text: "",
            url: ""
          }
        ];
  },
  data() {
    return {
      sectionName: null,
      elements: null,
      fieldsLabels: {
        text: this.$t("message.storeLocator.basic.urlText"),
        url: this.$t("message.storeLocator.basic.url")
      }
    };
  },
  methods: {
    addForm() {
      this.elements.push({
        text: "",
        url: ""
      });
    },
    removeForm() {
      this.elements.pop();
    },
    async validate() {
      return await this.$validator.validateAll();
    },
    collectErrors(field) {
      const errors = this.errors.collect(field);
      const fieldPrefix = field.split("_")[0];
      return errors.map(error =>
        error.replace(field, this.fieldsLabels[fieldPrefix])
      );
    }
  },
  watch: {
    elements: {
      handler() {
        this.$emit("update:data", this.elements);
      },
      deep: true
    },
    sectionName: {
      handler() {
        this.$emit("update:name", this.sectionName);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form:not(:first-of-type) {
  border-top: 1px solid $gray-200;
  padding-top: $spacing;
}

.form {
  margin-bottom: $spacing * 2;
}

.btn {
  margin-right: $spacing * 2;
}
</style>
